import { __decorate } from "tslib";
import Component from 'vue-class-component';
import StringUtils from '@/utils/stringUtils';
import authService from '@/services/authService';
import ReactiveComponent from '../components/ReactiveComponent';
import Task from '@/services/task';
import ProgressButton from "@/components/ProgressButton.vue";
let Login = class Login extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.email = process.env.VUE_APP_REMOTE_ENV === 'development' ? 'staff@pro1.com' : '';
        this.password = process.env.VUE_APP_REMOTE_ENV === 'development' ? 'foobar' : '';
        this.invalidEmail = false;
        this.invalidPassword = false;
        this.loginTask = Task.idle();
    }
    submit() {
        this.invalidEmail = StringUtils.isBlank(this.email);
        this.invalidPassword = StringUtils.isBlank(this.password);
        if (this.invalidEmail || this.invalidPassword) {
            return;
        }
        this.subscribe('login', authService.login(this.email, this.password), (task) => {
            console.log(`Login task: ${task}`);
            this.loginTask = task;
        });
    }
};
Login = __decorate([
    Component({
        components: { ProgressButton }
    })
], Login);
export default Login;
